import isNumber from 'lodash/isNumber';

import { bytesToUnit } from '@cast/utils';

import { TrafficDetailsTooltip } from './TrafficDetailsTooltip';
import { TrafficRatioBars } from './TrafficRatioBars';

import { Typography, Stack } from '@cast/design-system';
import type { StackProps } from '@cast/design-system';

type Props = {
  egress: number;
  ingress: number;
  total?: number;
  stackProps?: StackProps;
};

export const TrafficCell = ({ egress, ingress, total, stackProps }: Props) => {
  const [value, valueUnit] = bytesToUnit(
    isNumber(total) ? total : egress + ingress,
    3
  );

  if (!value) {
    return <>-</>;
  }

  return (
    <TrafficDetailsTooltip egress={egress} ingress={ingress}>
      <Stack gap={1} {...stackProps}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="P12R" noWrap>
            {value}
          </Typography>
          <Typography variant="P12R" color="textSecondary">
            {valueUnit}
          </Typography>
        </Stack>
        <TrafficRatioBars egress={egress} ingress={ingress} size="md" />
      </Stack>
    </TrafficDetailsTooltip>
  );
};
